import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTopMatchProfileDetailGroup extends Layout {
    sourceTopmatchDetailGroup: DataSource;
    tableComparisons: Table;
}
